import React, { useState, useRef } from 'react';
import cx from 'classnames';
import some from 'lodash/some';
import isEqual from 'lodash/isEqual';
import { createPortal } from 'react-dom';
import { usePlacement } from '../../../hooks/usePlacement';
import { useHandleOutsideClick } from '../../../hooks/useHandleOutsideClick';
import { ReactComponent as ArrowDropDown } from '../../../assets/img/icons/common/ArrowDropDown.svg';

import './FormMultiSelect.scss';

export const SimplifiedMultiSelect = ({ name, options, values, disabled, onChange }) => {
  const valuesRef = useRef(null);
  const [selectOpened, setSelectOpened] = useState(false);
  const { refs, floatingStyles } = usePlacement('bottom-start', selectOpened);

  useHandleOutsideClick(
    selectOpened,
    () => {
      setSelectOpened(false);
    },
    refs.floating,
    refs.reference
  );

  const handleSelectOption = value => {
    const newValues = some(values, item => isEqual(item, value))
      ? values.filter(item => !isEqual(item, value))
      : [...values, value];
    name ? onChange(name, newValues) : onChange(newValues);
  };

  return (
    <div
      ref={refs.setReference}
      className={cx('form-multi-select-filter', { opened: selectOpened, disabled })}
    >
      <div
        className="filter__toggle"
        onClick={() => {
          !disabled && setSelectOpened(prev => !prev);
        }}
      >
        <div className="filter__label-container">
          <span className="filter__label">
            {values && values.length > 0 ? (
              <div className="d-flex align-items-center overflow-hidden">
                <span ref={valuesRef} className="text-truncate">
                  {options.find(option => some(values, item => isEqual(item, option.value)))?.label}
                  {values.length > 1 ? ', ' : ''}
                </span>
                {values.length > 1 && <span>&nbsp;+{values.length - 1} more</span>}
              </div>
            ) : (
              <span className="filter__title">Select</span>
            )}
          </span>
        </div>
        <div className="filter__controls">
          <ArrowDropDown />
        </div>
      </div>

      {selectOpened &&
        createPortal(
          <div ref={refs.setFloating} style={floatingStyles} className="filter__dropdown-menu">
            <ul className="filter__dropdown-menu__options">
              {options.map((option, i) => (
                <li
                  key={i}
                  className={cx('option', {
                    active: some(values, item => isEqual(item, option.value)),
                    disabled: option.disabled,
                  })}
                  onClick={() => handleSelectOption(option.value)}
                >
                  <span className="option__label">{option.label}</span>
                </li>
              ))}
            </ul>
          </div>,
          document.getElementById('root')
        )}
    </div>
  );
};
